// Onglets des réglages en paysage (l'écran est bas : une seule catégorie à la fois). En portrait, tout reste dans une colonne qui défile :
// les onglets sont masqués par la feuille de style (main.css), qui ignore aussi la classe `tab-off`. Chaque élément de la fenêtre marqué
// `data-settings-tab="<id>"` appartient à un onglet ; `dev` désigne les éléments communs à tous les onglets de réglages de jeu.
export const GENERAL_TAB = 'general';
export const OFF_CLASS = 'tab-off';

/** L'élément marqué `tab` est-il visible quand `active` est l'onglet choisi ? */
export function belongsToTab(tab, active) {
  return tab === active || (tab === 'dev' && active !== GENERAL_TAB);
}

/** @param {HTMLElement} overlay  la fenêtre des réglages (#settingsOverlay) */
export function createSettingsTabs(overlay) {
  const tabs = [...overlay.querySelectorAll('.settings-tab')].filter((tab) => !tab.hidden); // les onglets d'une fonctionnalité mise de côté sont ignorés
  const items = [...overlay.querySelectorAll('[data-settings-tab]')];
  let active = GENERAL_TAB;

  function select(id, { focus = false } = {}) {
    if (!tabs.some((tab) => tab.dataset.tab === id)) id = GENERAL_TAB;
    active = id;
    for (const tab of tabs) {
      const on = tab.dataset.tab === id;
      tab.setAttribute('aria-selected', String(on));
      tab.tabIndex = on ? 0 : -1;
      tab.classList.toggle('is-active', on);
      if (on && focus) tab.focus();
    }
    for (const item of items) item.classList.toggle(OFF_CLASS, !belongsToTab(item.dataset.settingsTab, id));
    const current = tabs.find((tab) => tab.dataset.tab === id);
    current?.scrollIntoView?.({ block: 'nearest', inline: 'nearest' });
  }

  for (const tab of tabs) tab.addEventListener('click', () => select(tab.dataset.tab));
  overlay.querySelector('.settings-tabs')?.addEventListener('keydown', (event) => {
    const at = tabs.findIndex((tab) => tab.dataset.tab === active);
    const next = { ArrowRight: at + 1, ArrowLeft: at - 1, Home: 0, End: tabs.length - 1 }[event.key];
    if (next === undefined) return;
    event.preventDefault();
    select(tabs[(next + tabs.length) % tabs.length].dataset.tab, { focus: true });
  });

  select(GENERAL_TAB);
  return { select, active: () => active };
}
